import React, { useCallback, useEffect, useState } from "react";
import { GraduationCap, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { pillarApi, pillarErr, pillarDate } from "@/lib/pillarApi";

/** Staff: each homework lesson's score (4/5 unlocks the question) with a "Make them redo it" button. */
export function LessonResults({ residentId }) {
  const [d, setD] = useState(null);
  const load = useCallback(() => pillarApi.get(`/residents/${residentId}/lesson-results`).then(setD).catch(() => setD(null)), [residentId]);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const redo = async (x) => {
    if (!window.confirm("Reset this lesson so the resident goes through all 5 parts again?")) return;
    try { await pillarApi.post(`/residents/${residentId}/pillar-assignments/${x.id}/lesson-redo`, {}); toast.success("Lesson reset — they'll see it again"); load(); }
    catch (e) { toast.error(pillarErr(e)); }
  };
  return (
    <div data-testid="lesson-results" className="p-3 border border-white/10 rounded-sm space-y-2">
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted"><GraduationCap className="h-3.5 w-3.5 text-nex-gold" /> Homework lessons · pass {d.pass_mark}/5</div>
      {!d.results.length && <p className="text-xs text-nex-muted">No lessons started yet.</p>}
      {d.results.map((x) => (
        <div key={x.id} data-testid={`lesson-result-${x.id}`} className="flex items-center gap-3 text-sm">
          <span className={`font-mono text-base w-10 ${x.passed ? "text-emerald-300" : x.done ? "text-amber-300" : "text-nex-muted"}`}>{x.score}/5</span>
          <div className="flex-1 min-w-0">
            <div className="truncate text-nex-silver">Week {x.program_week} · {x.question || "Pillar question"}</div>
            <div className="text-[11px] text-nex-muted">
              {x.answers.map((a, i) => <span key={i} className={a === true ? "text-emerald-300" : a === false ? "text-red-300" : ""}>{a === true ? "✓" : a === false ? "✗" : "·"} </span>)}
              {x.passed ? " · unlocked" : x.done ? " · below pass mark — waiting on you" : " · in progress"}{x.completed_at ? ` · ${pillarDate(x.completed_at)}` : ""}{x.attempts > 1 ? ` · ${x.attempts} tries` : ""}
            </div>
          </div>
          {x.status === "pending" && (x.done || x.passed) && (
            <button type="button" onClick={() => redo(x)} data-testid={`lesson-redo-${x.id}`} className="inline-flex items-center gap-1 px-2 py-1 border border-white/15 text-[11px] text-nex-chrome hover:text-nex-gold"><RotateCcw className="h-3 w-3" /> Redo</button>
          )}
        </div>
      ))}
    </div>
  );
}
